import { render, staticRenderFns } from "./DOD_Intro4.vue?vue&type=template&id=ad78d3bc&scoped=true&"
import script from "./DOD_Intro4.vue?vue&type=script&lang=js&"
export * from "./DOD_Intro4.vue?vue&type=script&lang=js&"
import style0 from "./DOD_Intro4.vue?vue&type=style&index=0&id=ad78d3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad78d3bc",
  null
  
)

export default component.exports